import bookOneSymbol from "../assets/book-symbols/book-1-infinity.webp";
import bookTwoSymbol from "../assets/book-symbols/book-2-infinity.webp";
import bookThreeSymbol from "../assets/book-symbols/book-3-infinity.webp";
import "../book-symbol.css";

const symbols = [bookOneSymbol, bookTwoSymbol, bookThreeSymbol];

export default function BookSymbol({ number }) {
  return (
    <span className={`book-symbol book-symbol--${number}`} aria-hidden="true">
      <img src={symbols[number - 1]} alt="" width="112" height="112" decoding="async" />
    </span>
  );
}
